const processContent = (html) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");

  doc.querySelectorAll("img").forEach((img) => {
    const src = img.getAttribute("src");

    if (src && !src.startsWith("http")) {
      img.setAttribute(
        "src",
        `https://be-ofertas.utpl.edu.ec/${src.replace(/^\/+/, "")}`,
      );
    }
  });

  return doc.body.innerHTML;
};

function Investigacion({ content }) {
  return (
    <>
      <section className="  py-24">
        <div className="w-full max-w-6xl mx-auto   px-6 ">
          <div className="flex justify-center w-full  ">
            <p className="inline-flex items-center px-4 py-1.5 text-xs font-bold text-slate-700 bg-slate-100 border border-slate-200/80 rounded-full shadow-sm">
              Investigación
            </p>
           
          </div>
           <h2 className="text-center font-bold mb-6"> Descubre nuestra investigación</h2>
          <div
            className="
            [&_h2]:font-bold   [&_h2]:text-lg  [&_h2_strong]:text-lg
            link-with-arrow-1 grid md:grid-cols-2 lg:grid-cols-3 gap-6 [&>*]:bg-gray-50 [&>*]:p-6 [&>*]:rounded-2xl [&>*]:border [&>*]:border-slate-200/80 [&>*]:shadow-sm hover:[&>*]:shadow-md [&>*]:transition-all"
            dangerouslySetInnerHTML={{
              __html: processContent(content),
            }}
          />
        </div>{" "}
      </section>
    </>
  );
}

export default Investigacion;
